import React from "react";
import { Modal, ModalBody } from "reactstrap";

// Strings
import { getMessage } from "CONFIG/i18n";
import modalScrollBar from "COMPONENTS/ModalScrollBar/ModalScrollBar";

import "./speedTest.less";

class speedTestRunningModal extends React.Component {

  constructor() {
    super();
    this.state={
      countTime: 15,
    }
    this.countDownInterval = 0;
    this.timeoutInterval = 0;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show != this.props.show) {
      if (this.props.show) {
        this.countDownInterval = setInterval(() => {
          if (this.state.countTime <= 0) {
            clearInterval(this.countDownInterval)
            this.countDownInterval = 0;
          }
          if (this.state.countTime && this.state.countTime > 0) {
            const setTime = this.state.countTime - 1;
            this.setState({countTime: setTime})
          }
        }, 1000)  

        this.timeoutInterval = setTimeout(() => {
          this.props.handleSpeedTestTimeout();
        }, window._env_.SPEED_TEST_TIMEOUT_MSEC);
      } else {
        clearInterval(this.countDownInterval)
        this.countDownInterval = 0;
        clearTimeout(this.timeoutInterval)
        this.timeoutInterval = 0;
        this.setState({countTime: 15})
      }  
    }
  }

  componentWillUnmount() {
    clearInterval(this.countDownInterval)
    clearTimeout(this.timeoutInterval)
  }

  render() {
    return (
      <Modal
        isOpen={this.props.show}
        className="speedTestRunningModal"
        backdrop="static"
        zIndex={2147483647}
      >
        <ModalBody>
          <label>
            {getMessage("SPEED_TEST_IS_BEING_RERUN", {userName: this.props.userName})}
          </label>
          { this.props.speedTestParticipantId === this.props.uniqueId &&
            <div>
              {  this.state.countTime > 0
                ? <label>
                  {getMessage("REMAINING_TIME", {sec: this.state.countTime})}
                </label>
                : <label>
                  {getMessage("SPEED_TEST_PLEASE_WAIT")}
                </label>
              }
            </div>
          }
        </ModalBody>
      </Modal>
    );
  }
}

export default modalScrollBar(speedTestRunningModal);
